import { Drawer, DrawerProps, Stack, styled } from "@mui/material";
import * as React from "react";
import { useDispatch } from "react-redux";
import { SetDrawerOpen } from "../../../Redux/Reducers/redux-slice-layout";

export interface PanelProps extends DrawerProps {
  width?: number | string;
  withContainer?: boolean;
  header?: React.ReactNode;
  footerContent?: React.ReactNode;
  open?: boolean;
  reload?: any;
}

const DrawerWrapper: React.FC<PanelProps> = ({
  header,
  footerContent,
  withContainer = false,
  children,
  open = false,
  reload,
  ...otherProps
}) => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(SetDrawerOpen(open));

    return () => {
      dispatch(SetDrawerOpen(false));
    };
  }, [open]);
  return (
    <StyledPanel open={open} variant="temporary" width={440} anchor="right" {...otherProps}>
      {header}
      <PanelBody>{children}</PanelBody>
      {footerContent && (
        <PanelFooter direction="row" alignItems="center" spacing={1.5}>
          {footerContent}
        </PanelFooter>
      )}
    </StyledPanel>
  );
};

export default DrawerWrapper;

const StyledPanel = styled(Drawer, { shouldForwardProp: (prop) => prop !== "width" })<{ width: PanelProps["width"] }>(
  ({ theme, width }) => ({
    zIndex: theme.zIndex.modal,
    ".MuiDrawer-paper": {
      backgroundImage: "none",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      background: theme.palette.background.default,
      width: width,
      zIndex: theme.zIndex.modal,
    },
    ".MuiBackdrop-root": {
      backgroundColor: "rgba(0,0,0,0.4)",
    },
    ...theme.helpers(theme).scrollBar,
  })
);

const PanelFooter = styled(Stack)(({ theme }) => ({
  position: "sticky",
  bottom: 0,
  zIndex: 1,
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.backgroundAlpha.border}`,
  background: theme.palette.background.paper,
}));

const PanelBody = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  flex: 1,
}));
